export default __webpack_public_path__ + "static/media/tamara-en.995c8128.png";